// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3_QIy","description":"PatientConsentPreview_description__1chpz"};